import React, { createContext, useContext } from 'react';
import { useWellebitBluetooth } from '@/hooks/useWellebitBluetooth';

type WellebitBluetoothContextType = ReturnType<typeof useWellebitBluetooth>;

const WellebitBluetoothContext = createContext<WellebitBluetoothContextType | null>(null);

export function WellebitBluetoothProvider({ children }: { children: React.ReactNode }) {
  const bluetooth = useWellebitBluetooth();
  return (
    <WellebitBluetoothContext.Provider value={bluetooth}>
      {children}
    </WellebitBluetoothContext.Provider>
  );
}

export function useSharedBluetooth(): WellebitBluetoothContextType {
  const context = useContext(WellebitBluetoothContext);
  if (!context) {
    throw new Error('useSharedBluetooth must be used within WellebitBluetoothProvider');
  }
  return context;
}
